var map = {
  "./": [
    "77143",
    [
      700,
      369,
      318,
      580
    ]
  ],
  "./MoscowRoads.tsx": [
    "90224",
    [
      369
    ]
  ],
  "./index.ts": [
    "77143",
    [
      700,
      369,
      318,
      580
    ]
  ],
  "./SpbRoads.tsx": [
    "93911",
    [
      700
    ]
  ],
  "./RostovRoads": [
    "99925",
    [
      318
    ]
  ],
  "./index": [
    "77143",
    [
      700,
      369,
      318,
      580
    ]
  ],
  "./RostovRoads.tsx": [
    "99925",
    [
      318
    ]
  ],
  "./SpbRoads": [
    "93911",
    [
      700
    ]
  ],
  "./MoscowRoads": [
    "90224",
    [
      369
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return Promise.all(ids[1].map(function(chunkId) { return __webpack_require__.e(chunkId); })).then(() => (__webpack_require__(id)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 57640;
module.exports = __rspack_async_context;
